import { render, staticRenderFns } from "./Open.vue?vue&type=template&id=1af4553a&scoped=true&"
import script from "./Open.vue?vue&type=script&lang=js&"
export * from "./Open.vue?vue&type=script&lang=js&"
import style0 from "./Open.vue?vue&type=style&index=0&id=1af4553a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af4553a",
  null
  
)

export default component.exports